(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

const $0bfda0ad33e2db6a$var$TABLE_HEADER_CLASSES = [
    '.is-style-table-header-green-stripes',
    '.is-style-table-header-blue-stripes',
    '.is-style-table-header-green',
    '.is-style-table-header-blue'
];
class $0bfda0ad33e2db6a$export$2e2bcd8739ae039 {
    setup() {
        if (document.querySelector('.digital-publication-v2')) {
            const tables = document.querySelectorAll('.digital-publication-v2 .wp-block-table');
            this.addHeaderCells(tables);
        }
    }
    addHeaderCells(tables) {
        tables.forEach((table)=>{
            let twoHeaders = false;
            if (table.querySelectorAll($0bfda0ad33e2db6a$var$TABLE_HEADER_CLASSES.join(','))) {
                const rows = table.querySelectorAll('tbody > tr');
                rows.forEach((row, ri)=>{
                    const columns = row.querySelectorAll('td');
                    columns.forEach((column, ci)=>{
                        if (ri === 0) {
                            if (ci === 0 && !column.innerText.trim()) twoHeaders = true;
                            else this.addHeaderCell(column, 'col');
                        } else if (ci === 0 && twoHeaders) this.addHeaderCell(column, 'row');
                    });
                });
            }
        });
    }
    addHeaderCell(td, scope) {
        const th = document.createElement('th');
        th.setAttribute('scope', scope);
        th.innerHTML = td.innerHTML.trim();
        Array.from(td.attributes).forEach((attr)=>{
            th.setAttribute(attr.name, attr.value);
        });
        td.replaceWith(th);
    }
}


class $6ad3f5a9483ea81e$export$2e2bcd8739ae039 {
    setup() {
        if (document.querySelector('.digital-publication-v2')) {
            const footnoteRefs = document.querySelectorAll('sup a[href*="footnote"]:not([href*="-ref-"])');
            footnoteRefs && this.connectFootnotes(footnoteRefs);
        }
    }
    connectFootnotes(footnoteRefs) {
        footnoteRefs.forEach((footnoteRef)=>{
            const href = footnoteRef.getAttribute('href') || '';
            const hrefParts = href.split('-');
            const id = hrefParts.pop();
            const ref = hrefParts.join('-') + '-ref-' + id;
            if (footnoteRef && !footnoteRef.id) footnoteRef.id = ref.replace('#', '');
            const footnote = document.querySelector(`a[href="${ref}"]`);
            if (footnote && !footnote.id) footnote.id = href.replace('#', '');
        });
    }
}


const $ad19162f185c48e9$var$HIGHLIGHT_CLASS = 'search-highlight';
class $ad19162f185c48e9$export$2e2bcd8739ae039 {
    setup() {
        document.addEventListener('DOMContentLoaded', ()=>{
            this.matches = [];
            this.currentIndex = -1;
            this.initializeElements();
            this.addEventListeners();
            const urlParams = new URLSearchParams(window.location.search);
            const searchParam = urlParams.get('traff');
            if (searchParam) {
                this.searchInputs.forEach((input)=>input.value = searchParam);
                this.handleSearch({
                    target: {
                        value: searchParam
                    }
                });
                this.handleNext();
            }
        });
    }
    initializeElements() {
        this.searchBoxDevice = document.querySelector('.search-box.device');
        this.searchInputs = document.querySelectorAll('.search-input');
        this.searchButtons = document.querySelectorAll('.search-button');
        this.nextButtons = document.querySelectorAll('.next-button');
        this.prevButtons = document.querySelectorAll('.prev-button');
        this.searchStatus = document.querySelectorAll('.search-status');
        this.content = document.querySelector('.digital-publication');
        this.openSearchButton = document.querySelector('.open-search-button');
        this.closeSearchButton = document.querySelector('.close-search-button');
        this.clearButton = document.querySelector('.clear-button');
    }
    addEventListeners() {
        this.searchInputs.forEach((searchBox)=>{
            searchBox.addEventListener('keyup', this.handleSearch.bind(this));
            searchBox.addEventListener('keydown', this.handleSearchTrigger.bind(this));
        });
        this.searchButtons.forEach((searchButton)=>{
            searchButton.addEventListener('click', this.handleSearch.bind(this));
        });
        this.nextButtons.forEach((nextButton)=>{
            nextButton.addEventListener('click', this.handleNext.bind(this));
        });
        this.prevButtons.forEach((prevButton)=>{
            prevButton.addEventListener('click', this.handlePrev.bind(this));
        });
        this.openSearchButton.addEventListener('click', this.handleOpenSearch.bind(this));
        this.closeSearchButton.addEventListener('click', this.handleOpenSearch.bind(this));
        this.clearButton.addEventListener('click', this.handleClear.bind(this));
    }
    handleSearchTrigger(event) {
        if (event.key === 'Enter') this.handleNext();
    }
    handleOpenSearch() {
        this.handleClear();
        this.searchBoxDevice.classList.toggle('active');
        this.searchBoxDevice.closest('.head').classList.toggle('sticky-search');
    }
    handleSearch(event) {
        const searchText = event.target.value;
        if (!searchText) {
            this.handleClear();
            return;
        }
        this.searchInputs.forEach((searchBox)=>{
            searchBox.classList.add('active');
        });
        this.clearButton.classList.add('active');
        if (searchText.length < 3) return;
        this.highlightSearch(searchText);
        if (this.matches.length > 0) {
            this.nextButtons.forEach((button)=>button.disabled = false);
            this.prevButtons.forEach((button)=>button.disabled = false);
        } else {
            this.nextButtons.forEach((button)=>button.disabled = true);
            this.prevButtons.forEach((button)=>button.disabled = true);
        }
        this.updateSearchStatus();
        this.searchInputs.forEach((input)=>{
            input.value = searchText;
        });
    }
    handleNext() {
        if (this.matches.length > 0) {
            const nextIndex = (this.currentIndex + 1) % this.matches.length;
            this.scrollToMatch(nextIndex);
        }
    }
    handlePrev() {
        if (this.matches.length > 0) {
            const prevIndex = (this.currentIndex - 1 + this.matches.length) % this.matches.length;
            this.scrollToMatch(prevIndex);
        }
    }
    handleClear() {
        this.searchInputs.forEach((searchBox)=>searchBox.value = '');
        this.clearHighlights();
        this.matches = [];
        this.currentIndex = -1;
        this.nextButtons.forEach((button)=>button.disabled = true);
        this.prevButtons.forEach((button)=>button.disabled = true);
        this.updateSearchStatus();
        this.clearButton.classList.remove('active');
        this.searchInputs.forEach((searchBox)=>{
            searchBox.classList.remove('active');
        });
    }
    highlightSearch(text) {
        const regex = new RegExp(text.split('').join('\u00AD?'), 'gi');
        this.clearHighlights();
        const textNodes = this.getTextNodesMatchingRegex(regex);
        textNodes.forEach((node)=>{
            const fragment = this.createHighlightedFragment(node, regex);
            node.parentNode.replaceChild(fragment, node);
        });
    }
    getTextNodesMatchingRegex(regex) {
        let node;
        const textNodes = [];
        const walker = document.createTreeWalker(this.content, NodeFilter.SHOW_TEXT, null);
        while(node = walker.nextNode())if (node.nodeValue.match(regex) && !node.parentElement.closest('.digital-publication__toc') && !node.parentElement.closest('.read-more')) textNodes.push(node);
        return textNodes;
    }
    createHighlightedFragment(node, regex) {
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let match;
        while((match = regex.exec(node.nodeValue)) !== null){
            const part = node.nodeValue.substring(lastIndex, match.index);
            fragment.appendChild(document.createTextNode(part));
            const span = document.createElement('span');
            span.className = $ad19162f185c48e9$var$HIGHLIGHT_CLASS;
            span.textContent = match[0];
            fragment.appendChild(span);
            this.matches.push(span);
            lastIndex = regex.lastIndex;
        }
        fragment.appendChild(document.createTextNode(node.nodeValue.substring(lastIndex)));
        regex.lastIndex = 0;
        return fragment;
    }
    clearHighlights() {
        const highlightedElements = document.querySelectorAll('.' + $ad19162f185c48e9$var$HIGHLIGHT_CLASS);
        highlightedElements.forEach((element)=>{
            const parent = element.parentNode;
            parent.replaceChild(document.createTextNode(element.textContent), element);
            parent.normalize();
        });
        this.matches = [];
    }
    scrollToMatch(index) {
        if (index >= 0 && index < this.matches.length) {
            const target = this.matches[index];
            if (!target) return;
            document.querySelectorAll('.' + $ad19162f185c48e9$var$HIGHLIGHT_CLASS).forEach((element)=>{
                element.removeAttribute('aria-current');
            });
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.setAttribute('aria-current', 'true');
            target.scrollIntoView({
                behavior: prefersReducedMotion ? 'auto' : 'smooth',
                block: 'center'
            });
            this.currentIndex = index;
            this.updateSearchStatus();
            target.focus();
        }
    }
    updateSearchStatus() {
        const statusText = this.matches.length > 0 ? `${this.currentIndex + 1}/${this.matches.length}` : '0/0';
        this.searchStatus.forEach((status)=>{
            status.textContent = statusText;
        });
    }
}


class $c9b48db1fb3a53e3$export$2e2bcd8739ae039 {
    setup() {
        // Remove a tags without href
        document.querySelectorAll('a:not([href])').forEach((anchor)=>{
            const parent = anchor.parentNode;
            while(anchor.firstChild)parent.insertBefore(anchor.firstChild, anchor);
            parent.removeChild(anchor);
        });
    }
}


class $c1be32939f068d33$export$2e2bcd8739ae039 {
    rootElement = null;
    setup() {
        this.rootElement = document.querySelector('#content');
    }
    menuOpened() {
        this.rootElement.classList.add('menu-opened');
    }
    menuClosed() {
        this.rootElement.classList.remove('menu-opened');
    }
}


var $006636c5e42d23b4$exports = {};
'use strict';
var $006636c5e42d23b4$var$has = Object.prototype.hasOwnProperty, $006636c5e42d23b4$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $006636c5e42d23b4$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $006636c5e42d23b4$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $006636c5e42d23b4$var$Events().__proto__) $006636c5e42d23b4$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $006636c5e42d23b4$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $006636c5e42d23b4$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $006636c5e42d23b4$var$EE(fn, context || emitter, once), evt = $006636c5e42d23b4$var$prefix ? $006636c5e42d23b4$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $006636c5e42d23b4$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $006636c5e42d23b4$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $006636c5e42d23b4$var$EventEmitter() {
    this._events = new $006636c5e42d23b4$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($006636c5e42d23b4$var$has.call(events, name)) names.push($006636c5e42d23b4$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $006636c5e42d23b4$var$prefix ? $006636c5e42d23b4$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $006636c5e42d23b4$var$prefix ? $006636c5e42d23b4$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $006636c5e42d23b4$var$prefix ? $006636c5e42d23b4$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $006636c5e42d23b4$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $006636c5e42d23b4$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $006636c5e42d23b4$var$prefix ? $006636c5e42d23b4$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $006636c5e42d23b4$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $006636c5e42d23b4$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $006636c5e42d23b4$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $006636c5e42d23b4$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $006636c5e42d23b4$var$prefix ? $006636c5e42d23b4$var$prefix + event : event;
        if (this._events[evt]) $006636c5e42d23b4$var$clearEvent(this, evt);
    } else {
        this._events = new $006636c5e42d23b4$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$006636c5e42d23b4$var$EventEmitter.prototype.off = $006636c5e42d23b4$var$EventEmitter.prototype.removeListener;
$006636c5e42d23b4$var$EventEmitter.prototype.addListener = $006636c5e42d23b4$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$006636c5e42d23b4$var$EventEmitter.prefixed = $006636c5e42d23b4$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$006636c5e42d23b4$var$EventEmitter.EventEmitter = $006636c5e42d23b4$var$EventEmitter;
$006636c5e42d23b4$exports = $006636c5e42d23b4$var$EventEmitter;


function $db51e2ae2dbe7d9a$var$getHeadings(element) {
    return $db51e2ae2dbe7d9a$var$getElements(element, 'h2, h3');
}
function $db51e2ae2dbe7d9a$var$getElements(root, type) {
    const elements = root.querySelectorAll(type);
    return Array.from(elements).map((el)=>{
        const idel = el.querySelector('span[id]');
        if (idel) return {
            id: idel.getAttribute('id'),
            text: el.innerText,
            ref: el,
            level: $db51e2ae2dbe7d9a$var$typeToNum(el.nodeName),
            type: el.nodeName
        };
        return null;
    }).filter((el)=>el);
}
function $db51e2ae2dbe7d9a$var$typeToNum(type) {
    switch(type){
        case 'H1':
            return 0;
        case 'H2':
            return 1;
        case 'H3':
            return 2;
        case 'H4':
            return 3;
        case 'H5':
            return 4;
        case 'H6':
            return 5;
        default:
            return 6;
    }
}
function $db51e2ae2dbe7d9a$var$createElements(headings) {
    const root = document.querySelector('[data-toc]');
    let lastElement = null;
    let lastLevels = {};
    for(let i = 0; i < headings.length; i++){
        const heading = headings[i];
        if (!lastElement) lastElement = root;
        else if ($db51e2ae2dbe7d9a$var$typeToNum(lastElement.nodeName) >= heading.level) {
            // Find parent
            let parentLevel = heading.level - 1;
            let parent = null;
            while(!parent && parentLevel >= 0){
                parent = lastLevels[parentLevel];
                parentLevel--;
            }
            if (parent) lastElement = parent;
            else lastElement = root;
        }
        let next = document.createElement('div');
        next.classList.add('toc__level');
        next.classList.add('toc__level--' + heading.level);
        let content = document.createElement('div');
        content.classList.add('toc__content');
        next.appendChild(content);
        let link = document.createElement('a');
        link.setAttribute('href', `#${heading.id}`);
        link.classList.add('toc__link');
        link.classList.add('toc__link--' + heading.type);
        link.innerText = heading.text;
        content.appendChild(link);
        let children = lastElement.querySelector('.toc__children');
        if (heading.level === 1 && children && !heading.ref.closest('.about-publication')) {
            let expander = document.createElement('button');
            expander.classList.add('toc__expander');
            content.appendChild(expander);
        }
        if (!children) {
            children = document.createElement('div');
            children.classList.add('toc__children');
            lastElement.appendChild(children);
        }
        children.appendChild(next);
        lastElement = next;
        lastLevels[heading.level] = next;
    }
}
class $db51e2ae2dbe7d9a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($006636c5e42d23b4$exports))) {
    rootElement = null;
    setup() {
        this.rootElement = document.querySelector('#content');
        const headings = $db51e2ae2dbe7d9a$var$getHeadings(this.rootElement);
        $db51e2ae2dbe7d9a$var$createElements(headings);
        this.setupListeners(this.rootElement);
    }
    setupListeners(root) {
        let buttons = root.querySelectorAll('.toc__expander');
        let tocTopLinks = root.querySelectorAll('.toc > .toc__children > .toc__level > .toc__content .toc__link');
        const width = window.innerWidth;
        const breakMobile = 800;
        Array.from(buttons).forEach((button)=>{
            button.addEventListener('click', (e)=>{
                let parent = e.target.parentElement.closest('.toc__level');
                let isOpen = parent.classList.contains('toc__level--expanded');
                this.resetExpansion();
                this.resetActive();
                if (!isOpen) parent.classList.add('toc__level--expanded');
            });
        });
        let toc = root.querySelector('[data-toc]');
        toc.addEventListener('click', (e)=>{
            try {
                if (e.target.classList.contains('toc__link') && width <= breakMobile) this.emitClose();
            } catch (e) {}
        });
        tocTopLinks.forEach((link)=>{
            link.addEventListener('click', (e)=>{
                this.resetActive();
                e.target.closest('.toc__level').classList.add('toc__level--active');
                if (!e.target.closest('.toc__level--expanded')) {
                    if (this.resetExpansion() > 0) e.target.scrollIntoView({
                        block: "center"
                    });
                }
            });
        });
    }
    resetActive() {
        this.rootElement.querySelectorAll('.toc__level').forEach((level)=>{
            level.classList.remove('toc__level--active');
        });
    }
    resetExpansion() {
        let expanded = this.rootElement.querySelectorAll('.toc__level--expanded');
        let expandedLength = expanded.length;
        try {
            Array.from(expanded).forEach((element)=>element.classList.remove('toc__level--expanded'));
        } catch (error) {}
        return expandedLength;
    }
    emitClose() {
        this.emit('close');
    }
}


const $70f33be44cd83dbc$var$stickyClassName = 'sticky';
function $70f33be44cd83dbc$var$setupSticky(element) {
    let timeout = null;
    window.addEventListener('scroll', (e)=>{
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>{
            $70f33be44cd83dbc$var$checkSticky(element);
        }, 50);
    });
}
function $70f33be44cd83dbc$var$checkSticky(element) {
    let y = window.scrollY;
    let isSticky = element.classList.contains($70f33be44cd83dbc$var$stickyClassName);
    if (y > 0 && !isSticky) element.classList.add($70f33be44cd83dbc$var$stickyClassName);
    else if (y <= 0 && isSticky) element.classList.remove($70f33be44cd83dbc$var$stickyClassName);
}
class $70f33be44cd83dbc$export$2e2bcd8739ae039 {
    setup() {
        const rootElement = document.querySelector('#content .head');
        $70f33be44cd83dbc$var$setupSticky(rootElement);
        $70f33be44cd83dbc$var$checkSticky(rootElement);
    }
}



class $062e9d18e59338c3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($006636c5e42d23b4$exports))) {
    expanded = false;
    setup() {
        this.menu = document.querySelector('[data-menu]');
        this.content = document.querySelector('[data-menu-content]');
        const button = document.querySelector('[data-menu-toggle]');
        button.addEventListener('click', ()=>{
            if (!this.expanded) this.open();
            else this.close();
        });
    }
    close() {
        this.expanded = false;
        this.menu.classList.remove('menu--expanded');
        this.content.classList.remove('menu__content--expanded');
        this.emit('closed');
    }
    open() {
        this.expanded = true;
        this.menu.classList.add('menu--expanded');
        this.content.classList.add('menu__content--expanded');
        this.emit('opened');
    }
}



class $29a4770c486d76d1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($006636c5e42d23b4$exports))) {
    expanded = false;
    setup() {
        this.overlay = document.querySelector('[data-overlay]');
        const buttonopen = document.querySelector('[data-overlay-open-button]');
        const buttonopenmobile = document.querySelector('[data-overlay-open-button-mobile]');
        const buttonclose = document.querySelector('[data-overlay-close-button]');
        if (buttonopen) buttonopen.addEventListener('click', ()=>{
            this.open();
        });
        if (buttonopenmobile) buttonopenmobile.addEventListener('click', ()=>{
            this.open();
        });
        if (buttonclose) buttonclose.addEventListener('click', ()=>{
            this.close();
        });
    }
    close() {
        this.expanded = false;
        this.overlay.classList.remove('overlay--expanded');
        document.body.classList.remove('overlay--expanded');
    }
    open() {
        this.expanded = true;
        this.overlay.classList.add('overlay--expanded');
        document.body.classList.add('overlay--expanded');
    }
}


class $641714fe985d819a$export$2e2bcd8739ae039 {
    setup() {
        const headings = document.querySelectorAll('article.digital-publication h2');
        document.addEventListener('DOMContentLoaded', ()=>{
            if (headings.length > 0) this.wrapSummaryElements(headings);
        });
    }
    wrapSummaryElements(headings) {
        let resultsSummary = null;
        let summary = null;
        headings.forEach((element)=>{
            if (element.innerText.trim().toLowerCase() === 'resultat i korthet') resultsSummary = element;
            if (element.innerText.trim().toLowerCase() === 'sammanfattning') summary = element;
        });
        if (resultsSummary && summary) {
            // check to see if resultsSummary h2 and summary h2 are heading siblings
            for(let i = 0; i < headings.length; i++)if (headings[i] === resultsSummary && headings[i + 1] !== summary) {
                // Only wrap summary if resultsSummary and summary are not heading siblings
                resultsSummary = null;
                break;
            }
        }
        if (resultsSummary || summary) {
            const printSummaries = document.querySelectorAll('.print-summary');
            if (printSummaries.length > 0) printSummaries.forEach((printSummary)=>{
                printSummary.style.display = 'block';
            });
            const wrapper = document.createElement('div');
            wrapper.classList.add('summary-wrapper');
            if (resultsSummary) {
                let parent = resultsSummary.parentNode;
                let sibling = resultsSummary.nextElementSibling;
                parent.insertBefore(wrapper, sibling);
                wrapper.appendChild(resultsSummary);
                while(sibling && sibling.tagName !== 'H2'){
                    let nextSibling = sibling.nextElementSibling;
                    wrapper.appendChild(sibling);
                    sibling = nextSibling;
                }
            }
            if (summary) {
                let parent = summary.parentNode;
                let sibling = summary.nextElementSibling;
                if (!resultsSummary) parent.insertBefore(wrapper, sibling);
                wrapper.appendChild(summary);
                while(sibling && sibling.tagName !== 'H2'){
                    let nextSibling = sibling.nextElementSibling;
                    wrapper.appendChild(sibling);
                    sibling = nextSibling;
                }
            }
            // Parent window /www/wp-content/themes/vardanalys/assets/scripts/src/SummaryPrintHelper.js listens for this event
            const event = new CustomEvent('summaryWrapperAdded', {
                detail: {
                    selector: '.summary-wrapper'
                }
            });
            window.parent.document.dispatchEvent(event);
        }
    }
}


const $6b789edcbed18e35$var$tableHelper = new (0, $0bfda0ad33e2db6a$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$tableHelper.setup();
const $6b789edcbed18e35$var$footnoteHelper = new (0, $6ad3f5a9483ea81e$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$footnoteHelper.setup();
const $6b789edcbed18e35$var$searchHelper = new (0, $ad19162f185c48e9$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$searchHelper.setup();
const $6b789edcbed18e35$var$anchorHelper = new (0, $c9b48db1fb3a53e3$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$anchorHelper.setup();
const $6b789edcbed18e35$var$app = new (0, $c1be32939f068d33$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$app.setup();
const $6b789edcbed18e35$var$toc = new (0, $db51e2ae2dbe7d9a$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$toc.setup();
const $6b789edcbed18e35$var$head = new (0, $70f33be44cd83dbc$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$head.setup();
const $6b789edcbed18e35$var$menu = new (0, $062e9d18e59338c3$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$menu.setup();
const $6b789edcbed18e35$var$overlay = new (0, $29a4770c486d76d1$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$overlay.setup();
const $6b789edcbed18e35$var$summaryPrintHelper = new (0, $641714fe985d819a$export$2e2bcd8739ae039)();
$6b789edcbed18e35$var$summaryPrintHelper.setup();
// ----
// Listeners
const $6b789edcbed18e35$var$onMenuOpened = ()=>{
    $6b789edcbed18e35$var$app.menuOpened();
};
const $6b789edcbed18e35$var$onMenuClosed = ()=>{
    $6b789edcbed18e35$var$toc.resetExpansion();
    $6b789edcbed18e35$var$app.menuClosed();
};
$6b789edcbed18e35$var$toc.addListener('close', ()=>$6b789edcbed18e35$var$menu.close());
$6b789edcbed18e35$var$menu.addListener('closed', $6b789edcbed18e35$var$onMenuClosed);
$6b789edcbed18e35$var$menu.addListener('opened', $6b789edcbed18e35$var$onMenuOpened);

})();
//# sourceMappingURL=index.js.map
